import { GET_NOTIFICATION_LIST, GET_HEADER_COUNT } from "../actions/types";

const initialState = {
    notificationList: [],
    headerCount: {},
    loading: false,
};

const notificationReducers = (state = initialState, action) => {
    switch (action.type) {
        case GET_NOTIFICATION_LIST:
            return {...state, loading: false, notificationList: action.payload };
        case GET_HEADER_COUNT:
            return {...state, loading: false, headerCount: action.payload };
        default:
            return state;
    }
};

export default notificationReducers;
